import Vue from 'vue';

const parseValue = function parseValue(binding) {
    let {value, modifiers} = binding;

    return modifiers.space
        ? `${value} `
        : value;
};

Vue.directive('prepend', {
    inserted: function (element, binding) {
        if (!binding.value) {
            return;
        }

        const value = parseValue(binding);

        element.insertAdjacentText('beforebegin', value);
        element.prependedTextNode = element.previousSibling;
    },

    unbind: function (element, binding) {
        if (!binding.value) {
            return;
        }

        const value = parseValue(binding);
        const node = element.prependedTextNode;

        if (node && node.nodeType === node.TEXT_NODE && node.data === value) {
            node.remove();
        }
    },
});
